import { render, staticRenderFns } from "./examinDetail.vue?vue&type=template&id=3bbb3092&"
import script from "./examinDetail.vue?vue&type=script&lang=js&"
export * from "./examinDetail.vue?vue&type=script&lang=js&"
import style0 from "./examinDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports